"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import { useVotingModalState } from "@/components/voting/useVotingModalState";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import DropCurationButton from "@/components/waves/drops/DropCurationButton";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuCopyLink from "@/components/waves/drops/WaveDropMobileMenuCopyLink";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import React from "react";
import { createPortal } from "react-dom";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropAuthorAvatar } from "./header/WaveLeaderboardDropAuthor";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
  readonly mediaContainerHeightClassName?: string | undefined;
  readonly contentPresentation?: DropContentPresentation;
}
const isClickFromCardDom = (event: React.MouseEvent<HTMLDivElement>): boolean => {
  return event.currentTarget.contains(event.target as Node);
};
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(83);
  const {
    drop,
    onDropClick,
    winningThreshold,
    isVotingClosed: t1,
    isVotingControlsLocked: t2,
    mediaContainerHeightClassName,
    contentPresentation: t3
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const isVotingControlsLocked = t2 === undefined ? false : t2;
  const contentPresentation = t3 === undefined ? "default" : t3;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const canShowVotingAction = canShowVote && !isVotingActionLocked;
  const {
    isOpen: isVoteModalOpen,
    open: openVoteModal,
    close: closeVoteModal
  } = useVotingModalState(isVotingActionLocked);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  const suppressNextClickRef = React.useRef(false);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      suppressNextClickRef.current = true;
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const handleInteractionStart = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      if (!suppressNextClickRef.current) {
        return;
      }
      suppressNextClickRef.current = false;
      event.preventDefault();
      event.stopPropagation();
    };
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const handleClickCapture = t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      suppressNextClickRef.current = false;
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const clearPendingLongPressClick = t6;
  let t7;
  if ($[3] !== hasTouchScreen) {
    t7 = {
      hasTouchScreen,
      onInteractionStart: handleInteractionStart,
      preventDefault: false
    };
    $[3] = hasTouchScreen;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t7);
  let t8;
  if ($[5] !== setIsActive) {
    t8 = nextIsActive => {
      if (!nextIsActive) {
        suppressNextClickRef.current = false;
      }
      setIsActive(nextIsActive);
    };
    $[5] = setIsActive;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const handleMobileMenuOpenChange = t8;
  let t9;
  if ($[7] !== handleMobileMenuOpenChange) {
    t9 = () => {
      handleMobileMenuOpenChange(false);
    };
    $[7] = handleMobileMenuOpenChange;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const handleMobileMenuClose = t9;
  const getBorderClasses = _temp;
  let t10;
  if ($[9] !== openVoteModal) {
    t10 = () => {
      openVoteModal();
    };
    $[9] = openVoteModal;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const handleVoteButtonClick = t10;
  let t11;
  if ($[11] !== drop || $[12] !== isMobileScreen || $[13] !== onDropClick) {
    t11 = event_0 => {
      if (!isClickFromCardDom(event_0)) {
        return;
      }
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_list",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[11] = drop;
    $[12] = isMobileScreen;
    $[13] = onDropClick;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const handleClick = t11;
  let t12;
  if ($[15] !== drop) {
    t12 = <div className="tw-flex-shrink-0 tw-self-start"><WaveLeaderboardDropAuthorAvatar drop={drop} /></div>;
    $[15] = drop;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== drop || $[18] !== winningThreshold) {
    t13 = <WaveLeaderboardDropHeader drop={drop} showAvatar={false} winningThreshold={winningThreshold} />;
    $[17] = drop;
    $[18] = winningThreshold;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== drop) {
    t14 = <div className="tw-hidden tw-h-8 lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[20] = drop;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== canDelete || $[23] !== drop) {
    t15 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[22] = canDelete;
    $[23] = drop;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15) {
    t16 = <div className="tw-hidden tw-h-8 lg:tw-block">{t15}</div>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <div className="tw-flex tw-items-center">{t14}{t16}</div>;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t13 || $[31] !== t17) {
    t18 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t13}{t17}</div>;
    $[30] = t13;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== contentPresentation || $[34] !== drop || $[35] !== mediaContainerHeightClassName) {
    t19 = <WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} mediaContainerHeightClassName={mediaContainerHeightClassName} contentPresentation={contentPresentation} />;
    $[33] = contentPresentation;
    $[34] = drop;
    $[35] = mediaContainerHeightClassName;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== drop || $[38] !== isVotingClosed || $[39] !== winningThreshold) {
    t20 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><WaveLeaderboardDropRaters drop={drop} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} /></div>;
    $[37] = drop;
    $[38] = isVotingClosed;
    $[39] = winningThreshold;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const t21 = drop.context_profile_context?.curatable ?? false;
  const t22 = drop.context_profile_context?.curated ?? false;
  let t23;
  if ($[41] !== drop.id || $[42] !== drop.wave.id || $[43] !== t21 || $[44] !== t22) {
    t23 = <DropCurationButton waveId={drop.wave.id} dropId={drop.id} isCuratable={t21} isCurated={t22} />;
    $[41] = drop.id;
    $[42] = drop.wave.id;
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== canShowVotingAction || $[47] !== drop || $[48] !== handleVoteButtonClick) {
    t24 = canShowVotingAction && <VotingModalButton drop={drop} onClick={handleVoteButtonClick} className="tw-font-semibold" />;
    $[46] = canShowVotingAction;
    $[47] = drop;
    $[48] = handleVoteButtonClick;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t23 || $[51] !== t24) {
    t25 = <div className="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-t-0 @[700px]:tw-pt-0" onClick={_temp2}>{t23}{t24}</div>;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t20 || $[54] !== t25) {
    t26 = <div className="tw-mt-3 tw-flex tw-w-full tw-flex-col tw-justify-between tw-gap-x-2 tw-space-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-space-y-0">{t20}{t25}</div>;
    $[53] = t20;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t18 || $[57] !== t19 || $[58] !== t26) {
    t27 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">{t18}{t19}{t26}</div>;
    $[56] = t18;
    $[57] = t19;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t12 || $[61] !== t27) {
    t28 = <div className="tw-flex tw-gap-x-3">{t12}{t27}</div>;
    $[60] = t12;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t28 || $[64] !== touchHandlers) {
    t29 = <div className={getBorderClasses()} {...touchHandlers}>{t28}</div>;
    $[63] = t28;
    $[64] = touchHandlers;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== closeVoteModal || $[67] !== drop || $[68] !== isMobileScreen || $[69] !== isVoteModalOpen) {
    t30 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVoteModalOpen} onClose={closeVoteModal} /> : <VotingModal drop={drop} isOpen={isVoteModalOpen} onClose={closeVoteModal} />;
    $[66] = closeVoteModal;
    $[67] = drop;
    $[68] = isMobileScreen;
    $[69] = isVoteModalOpen;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== canDelete || $[72] !== drop || $[73] !== handleMobileMenuClose || $[74] !== handleMobileMenuOpenChange || $[75] !== hasTouchScreen || $[76] !== isActive) {
    t31 = hasTouchScreen && createPortal(<div onPointerDownCapture={clearPendingLongPressClick} onTouchStartCapture={clearPendingLongPressClick}><CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={handleMobileMenuOpenChange}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={handleMobileMenuClose} /><WaveDropMobileMenuCopyLink drop={drop} onCopy={handleMobileMenuClose} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={handleMobileMenuClose} />}</div></CommonDropdownItemsMobileWrapper></div>, document.body);
    $[71] = canDelete;
    $[72] = drop;
    $[73] = handleMobileMenuClose;
    $[74] = handleMobileMenuOpenChange;
    $[75] = hasTouchScreen;
    $[76] = isActive;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== handleClick || $[79] !== t29 || $[80] !== t30 || $[81] !== t31) {
    t32 = <div onClickCapture={handleClickCapture} onClick={handleClick} className="tw-group tw-relative tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-@container">{t29}{t30}{t31}</div>;
    $[78] = handleClick;
    $[79] = t29;
    $[80] = t30;
    $[81] = t31;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  return t32;
};
function _temp() {
  return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
}
function _temp2(e) {
  return e.stopPropagation();
}